import House from "./house";

export default House;
